// extracted by mini-css-extract-plugin
export default {"icon":"icon__44e014c3"};